import type { InterventionType } from '@dhl/interventions'

export const paths = {
  CONSOLIDATED_INTERVENTIONS: 'consolidated',
  CONFIRM: 'confirm',
}

type ConsolidatedInterventionParams = {
  ids: string
  type?: InterventionType
}

export const interventionLinks = {
  consolidatedIntervention: (): string => `/${paths.CONSOLIDATED_INTERVENTIONS}`,
  consolidatedInterventionDetail: ({ ids }: ConsolidatedInterventionParams): string =>
    `/${paths.CONSOLIDATED_INTERVENTIONS}/${ids}`,
  consolidatedInterventionDetailType: ({ ids, type }: ConsolidatedInterventionParams): string =>
    `/${paths.CONSOLIDATED_INTERVENTIONS}/${ids}/${type}`,
  consolidatedInterventionDetailConfirm: ({ ids }: ConsolidatedInterventionParams): string =>
    `/${paths.CONSOLIDATED_INTERVENTIONS}/${ids}/${paths.CONFIRM}`,
}

export type InterventionLinks = typeof interventionLinks
